/* eslint-disable no-unused-vars */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setSession} from '../../actions/action_session';
import SessionDetails from '../SessionDetails/SessionDetails';

function mapStateToProps(state) {
    // Each container component will likely only pull in the state that
    // it cares about. Doing so will eliminate unnecessary rerenders.
    return (
        {session: state.session}
    );
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({setSession}, dispatch);
}

@connect(mapStateToProps, mapDispatchToProps)
class SessionCheckContainer extends Component {
    render() {
        if (this.props.session && this.props.session.isImpersonating === true) {
            return <SessionDetails {...this.props} />;
        }
        return (
            <div>
                <h1 className="sessionState"> {'Session found but not impersonating'} </h1>
            </div>);
    }
}

export default SessionCheckContainer;
